var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", [
    _c("td", { staticClass: "options", attrs: { colspan: "8" } }, [
      _c("div", [
        _c("div", [
          _c("div", { staticClass: "optionsPanel" }, [
            _c("div", { staticClass: "optionsPanel__image" }, [
              _c("img", {
                staticClass: "manufacturer_image",
                class: {
                  "height-250":
                    _vm.model.manufacturer_id === 5 ||
                    _vm.model.manufacturer_id === 2
                },
                staticStyle: { "max-width": "300px" },
                attrs: { src: _vm.manufacturerImage(_vm.model.manufacturer_id) }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "optionsPanel__content optionsPanel__content--borderTop"
              },
              [
                _c("h5", [
                  _vm._v("Total current cost per annum "),
                  _c("span", {
                    staticClass: "cost",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.makeNumberWithPound(
                          _vm.current_costs.total_cost_per_annum.toFixed(2)
                        )
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("span", { staticClass: "cost" }, [
                    _vm._v("\n                ("),
                    _c("span", {
                      staticStyle: {
                        "font-size": "inherit",
                        "font-weight": "inherit"
                      },
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.makeNumberWithPound(
                            (
                              _vm.current_costs.total_cost_per_annum / 4
                            ).toFixed(2)
                          )
                        )
                      }
                    }),
                    _vm._v(" per quarter)\n              ")
                  ])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "small" }, [
                  _vm._v(
                    "*Calculated using existing service costs, consumable costs, postage\n              recredits, invoice fees and insurance fees\n              where applicable based on information provided"
                  )
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", [
          _c("table", { staticClass: "featureTable" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("tbody", [
              _c("tr", [
                _c("td", [
                  _vm._v("\n              Printing capabilities\n            ")
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.model.printing_capabilities) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _vm._m(1)
              ]),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _c("tr", [
                _c("td", [
                  _vm._v("\n              Programmable jobs\n            ")
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.model.programmable_jobs) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _vm._m(3)
              ]),
              _vm._v(" "),
              _vm._m(4),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_vm._v("\n              Ink yield\n            ")]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.model.ink_yield) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _vm._m(5)
              ]),
              _vm._v(" "),
              _vm._m(6),
              _vm._v(" "),
              _c("tr", [
                _c("td", [
                  _vm._v("\n              Cost per impression\n            ")
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.model.cost_per_impression) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _vm._m(7)
              ]),
              _vm._v(" "),
              _vm._m(8),
              _vm._v(" "),
              _c("tr", [
                _c("td", [
                  _vm._v(
                    "\n              Logo return address capacity\n            "
                  )
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.model.return_address_capacity) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _vm._m(9)
              ]),
              _vm._v(" "),
              _vm._m(10),
              _vm._v(" "),
              _c("tr", [
                _c("td", [
                  _vm._v("\n              Interface type\n            ")
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.model.interface_type) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _vm._m(11)
              ]),
              _vm._v(" "),
              _vm._m(12),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_vm._v("\n              Mail feeder\n            ")]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.model.mail_feeder) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _vm._m(13)
              ]),
              _vm._v(" "),
              _vm._m(14),
              _vm._v(" "),
              _c("tr", [
                _c("td", [
                  _vm._v("\n              Label dispenser\n            ")
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.model.label_dispenser) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _vm._m(15)
              ]),
              _vm._v(" "),
              _vm._m(16),
              _vm._v(" "),
              _c("tr", [
                _c("td", [
                  _vm._v("\n              Web based reporting\n            ")
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm.model.web_based_reporting === "yes"
                    ? _c("img", {
                        attrs: {
                          src: require("./../../../../static/styles/mailkit/img/tick.png")
                        }
                      })
                    : _c("img", {
                        attrs: {
                          src: require("./../../../../static/styles/mailkit/img/cross.png")
                        }
                      })
                ]),
                _vm._v(" "),
                _vm._m(17)
              ]),
              _vm._v(" "),
              _vm._m(18),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_vm._v("\n              Dimensions\n            ")]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.model.dimensions) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _vm._m(19)
              ]),
              _vm._v(" "),
              _vm._m(20),
              _vm._v(" "),
              _c("tr", [
                _c("td", [
                  _vm._v("\n              Mail mark compliant\n            ")
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm.model.mail_mark_compliant === "yes"
                    ? _c("img", {
                        attrs: {
                          src: require("./../../../../static/styles/mailkit/img/tick.png")
                        }
                      })
                    : _c("img", {
                        attrs: {
                          src: require("./../../../../static/styles/mailkit/img/cross.png")
                        }
                      })
                ]),
                _vm._v(" "),
                _vm._m(21)
              ]),
              _vm._v(" "),
              _vm._m(22),
              _vm._v(" "),
              _c("tr", [
                _c("td", [
                  _vm._v(
                    "\n              Installation and training\n            "
                  )
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm.model.engineer_installation_training === "Included"
                    ? _c("img", {
                        attrs: {
                          src: require("./../../../../static/styles/mailkit/img/tick.png")
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.model.engineer_installation_training === null ||
                  _vm.model.engineer_installation_training ===
                    "Not Included (Available at additional cost)"
                    ? _c("img", {
                        attrs: {
                          src: require("./../../../../static/styles/mailkit/img/cross.png")
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.model.engineer_installation_training ===
                  "Not Included (Available at additional cost)"
                    ? _c("span", [
                        _c("br"),
                        _vm._v(
                          "\n                Available at additional cost £" +
                            _vm._s(
                              _vm.model
                                .engineer_installation_training_sell_price
                            ) +
                            "\n              "
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm._m(23)
              ]),
              _vm._v(" "),
              _vm._m(24),
              _vm._v(" "),
              _c("tr", [
                _c("td", [
                  _vm._v("\n              Scale capacity\n            ")
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.model.scale_capacity) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _vm._m(25)
              ]),
              _vm._v(" "),
              _vm._m(26),
              _vm._v(" "),
              _c("tr", [
                _c("td", { staticStyle: { "text-transform": "uppercase" } }, [
                  _vm._v(
                    "\n              Custom Logo/Return Address Included with New Machine\n            "
                  )
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm.model.return_address_included_with_machine === "Included"
                    ? _c("img", {
                        attrs: {
                          src: require("./../../../../static/styles/mailkit/img/tick.png")
                        }
                      })
                    : _c("span", [
                        _c("img", {
                          attrs: {
                            src: require("./../../../../static/styles/mailkit/img/cross.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "Available at additional cost - £" +
                              _vm._s(_vm.model.return_address_sell_price) +
                              " "
                          )
                        ])
                      ])
                ]),
                _vm._v(" "),
                _vm._m(27)
              ]),
              _vm._v(" "),
              _vm._m(28),
              _vm._v(" "),
              _c("tr", [
                _c("td", { staticStyle: { "text-transform": "uppercase" } }, [
                  _vm._v("\n              Business mail advanced\n            ")
                ]),
                _vm._v(" "),
                _c("td", [
                  !_vm.model.business_mail_advanced.includes("included")
                    ? _c("span", [
                        _c("img", {
                          attrs: {
                            src: require("./../../../../static/styles/mailkit/img/cross.png")
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.model.business_mail_advanced.includes("included")
                    ? _c("span", [
                        _c("img", {
                          attrs: {
                            src: require("./../../../../static/styles/mailkit/img/cross.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "Available at additional cost - £" +
                              _vm._s(
                                _vm.model.business_mail_advanced_sell_price
                              ) +
                              " "
                          )
                        ])
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm._m(29)
              ]),
              _vm._v(" "),
              _vm._m(30),
              _vm._v(" "),
              _c("tr", [
                _c("td", [
                  _vm._v(
                    "\n              Connectivity kit options\n            "
                  )
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.model.connectivity) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _vm._m(31)
              ]),
              _vm._v(" "),
              _vm._m(32),
              _vm._v(" "),
              _c("tr", [
                _c("td", [
                  _vm._v(
                    "\n              Inbound courier parcel tracing\n            "
                  )
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm.model.integrated_internal_mail_tracking_app.includes(
                    "Included"
                  )
                    ? _c("img", {
                        attrs: {
                          src: require("./../../../../static/styles/mailkit/img/tick.png")
                        }
                      })
                    : _c("img", {
                        attrs: {
                          src: require("./../../../../static/styles/mailkit/img/cross.png")
                        }
                      }),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.model.integrated_internal_mail_tracking_app) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _vm._m(33)
              ]),
              _vm._v(" "),
              _vm._m(34),
              _vm._v(" "),
              _c("tr", [
                _c("td", [
                  _vm._v(
                    "\n              Outbound shipping application\n            "
                  )
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.model.shipping_application) +
                      "\n              "
                  ),
                  _vm.model.shipping_application ===
                  "Yes Single User Included (Optional Kit available includes 30kg Scale and Shipping Label Printer)"
                    ? _c("span", [
                        _vm._v(
                          "\n                Available at additional cost - £" +
                            _vm._s(
                              _vm.model.shipping_application_kit_sell_price
                            ) +
                            "\n              "
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm._m(35)
              ]),
              _vm._v(" "),
              _vm._m(36),
              _vm._v(" "),
              _c("tr", [
                _c("td", [
                  _vm._v(
                    "\n              Departmental accounting\n            "
                  )
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.model.departmental_accounting) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _vm._m(37)
              ]),
              _vm._v(" "),
              _vm._m(38),
              _vm._v(" "),
              _c("tr", [
                _c("td", [
                  _vm._v("\n              Differential weighing\n            ")
                ]),
                _vm._v(" "),
                _c("td", [
                  !_vm.model.differential_weighting ||
                  _vm.model.differential_weighting === "No"
                    ? _c("img", {
                        attrs: {
                          src: require("./../../../../static/styles/mailkit/img/cross.png")
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.model.differential_weighting === "Yes" ||
                  _vm.model.differential_weighting === "Optional"
                    ? _c("span", [
                        _vm._v(
                          "Available at additional cost £" +
                            _vm._s(_vm.model.differential_weighing_sell_price)
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm._m(39)
              ]),
              _vm._v(" "),
              _vm._m(40),
              _vm._v(" "),
              _c("tr", { staticStyle: { background: "#f4f4f4" } }, [
                _c("td", [
                  _vm._v(
                    "\n              Service / maintenance offering\n            "
                  )
                ]),
                _vm._v(" "),
                _c("td", [
                  !_vm.service_upgrade &&
                  !_vm.new_costs.postage_recredit_costs_updated_to_total_care
                    ? _c("span", [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.model.service_name) +
                            "\n              "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.service_upgrade == "swapit"
                    ? _c("span", [
                        _vm._v("\n                swapit+\n              ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.service_upgrade == "total_care" ||
                  _vm.new_costs.postage_recredit_costs_updated_to_total_care
                    ? _c("span", [
                        _vm._v("\n                total care\n              ")
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("td")
              ]),
              _vm._v(" "),
              _vm._m(41),
              _vm._v(" "),
              _c("tr", { staticStyle: { background: "#f4f4f4" } }, [
                _c("td", [_vm._v("\n              First step\n            ")]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.model.first_step) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c("td")
              ]),
              _vm._v(" "),
              _vm._m(42),
              _vm._v(" "),
              _c("tr", { staticStyle: { background: "#f4f4f4" } }, [
                _c("td", [_vm._v("\n              Second step\n            ")]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.model.second_step) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c("td")
              ]),
              _vm._v(" "),
              _vm._m(43),
              _vm._v(" "),
              _c("tr", { staticStyle: { background: "#f4f4f4" } }, [
                _c("td", [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.service_upgrade ||
                          _vm.new_costs
                            .postage_recredit_costs_updated_to_total_care
                          ? "Enhanced"
                          : null
                      ) +
                      " Third step\n            "
                  )
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.service_upgrade ||
                          _vm.new_costs
                            .postage_recredit_costs_updated_to_total_care
                          ? _vm.model.enhanced_third_step
                          : _vm.model.third_step
                      ) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c("td")
              ]),
              _vm._v(" "),
              _vm._m(44),
              _vm._v(" "),
              _c("tr", { staticStyle: { background: "#f4f4f4" } }, [
                _c("td", [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.service_upgrade ||
                          _vm.new_costs
                            .postage_recredit_costs_updated_to_total_care
                          ? "Enhanced"
                          : null
                      ) +
                      " Targeted service level\n            "
                  )
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.service_upgrade ||
                          _vm.new_costs
                            .postage_recredit_costs_updated_to_total_care
                          ? _vm.model.sla_enhanced
                          : _vm.model.sla_standard
                      ) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c("td")
              ]),
              _vm._v(" "),
              _vm._m(45),
              _vm._v(" "),
              _c("tr", { staticStyle: { background: "#f4f4f4" } }, [
                _c("td", [_vm._v("\n              All parts\n            ")]),
                _vm._v(" "),
                _c("td", [
                  _vm.model.all_parts === null
                    ? _c("img", {
                        attrs: {
                          src: require("./../../../../static/styles/mailkit/img/cross.png")
                        }
                      })
                    : _c("span", [
                        _c("img", {
                          attrs: {
                            src: require("./../../../../static/styles/mailkit/img/tick.png")
                          }
                        }),
                        _vm._v(" Yes\n              ")
                      ])
                ]),
                _vm._v(" "),
                _c("td")
              ]),
              _vm._v(" "),
              _vm._m(46),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_vm._v("\n              All labour\n            ")]),
                _vm._v(" "),
                _c("td", [
                  _vm.model.all_labour === null
                    ? _c("img", {
                        attrs: {
                          src: require("./../../../../static/styles/mailkit/img/cross.png")
                        }
                      })
                    : _c("span", [
                        _c("img", {
                          attrs: {
                            src: require("./../../../../static/styles/mailkit/img/tick.png")
                          }
                        }),
                        _vm._v(" Yes\n              ")
                      ])
                ]),
                _vm._v(" "),
                _c("td")
              ]),
              _vm._v(" "),
              _vm._m(47),
              _vm._v(" "),
              _c("tr", { staticStyle: { background: "#f4f4f4" } }, [
                _c("td", [
                  _vm._v("\n              Wwear & tear\n            ")
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm.model.wear_and_tear === null
                    ? _c("img", {
                        attrs: {
                          src: require("./../../../../static/styles/mailkit/img/cross.png")
                        }
                      })
                    : _c("span", [
                        _c("img", {
                          attrs: {
                            src: require("./../../../../static/styles/mailkit/img/tick.png")
                          }
                        }),
                        _vm._v(
                          " Yes - excluding consumable parts\n              "
                        )
                      ])
                ]),
                _vm._v(" "),
                _c("td")
              ]),
              _vm._v(" "),
              _vm._m(48),
              _vm._v(" "),
              _c("tr", { staticStyle: { background: "white" } }, [
                _c("td", [
                  _vm._v(
                    "\n              Royal Mail rate updates\n            "
                  )
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.model.tariff_rate_updates_included_per_annum) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c("td")
              ]),
              _vm._v(" "),
              _vm._m(49),
              _vm._v(" "),
              _c("tr", { staticStyle: { background: "#f4f4f4" } }, [
                _c("td", [
                  _vm._v("\n              Postage account type\n            ")
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.model.manufacturer_id == 3 ||
                          _vm.model.manufacturer_id == 2
                          ? "Arvanced or arrears"
                          : "Advanced"
                      ) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c("td")
              ]),
              _vm._v(" "),
              _vm._m(50)
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("th", [_vm._v("\n            Feature\n          ")]),
      _vm._v(" "),
      _c("th", [_vm._v("\n            Specification\n          ")]),
      _vm._v(" "),
      _c("th", [_vm._v("\n            Info and upgrade options\n          ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "PRINTING CAPABILITIES" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "PROGRAMMABLE JOBS" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "INK YIELD" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "COST PER IMPRESSION" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "LOGO RETURN ADDRESS CAPACITY" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "INTERFACE TYPE" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "MAIL FEEDER" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "LABEL DISPENSER" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "WEB BASED REPORTING" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "DIMENSIONS" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "MAIL MARK COMPLIANT" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "INSTALLATION AND TRAINING" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "SCALE CAPACITY" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: {
            "data-ft": "CUSTOM LOGO/RETURN ADDRESS INCLUDED WITH NEW MACHINE"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "BUSINESS MAIL ADVANCED" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "CONNECTIVITY KIT OPTIONS" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "INBOUND COURIER PARCEL TRACING" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "OUTBOUND SHIPPING APPLICATION" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "DEPARTMENTAL ACCOUNTING" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "DIFFERENTIAL WEIGHING" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "SERVICE / MAINTENANCE OFFERING" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "FIRST STEP" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "SECOND STEP" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "THIRD STEP" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "TARGETED SERVICE LEVEL" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "ALL PARTS" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "ALL LABOUR" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "WEAR & TEAR" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "ROYAL MAIL RATE UPDATES" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "POSTAGE ACCOUNT TYPE" }
        })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f6cbd76", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f6cbd76","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ProposalTemplate/Partials/SummaryMoreInfo.vue
// module id = null
// module chunks = 